import { FORMS, getLabelFromValue } from '@pangea-lis-apps/utils';
import { Fragment } from 'react';

export interface AddressProps {
	data: {
		address?: string | null;
		address2?: string | null;
		city?: string | null;
		state?: string | null;
		zipCode?: string | null;
		country?: string | null;
	};
}

export function Address({
	data: { address, address2, city, state, zipCode, country },
}: AddressProps) {
	return (
		<p>
			{address}
			<br />
			{address2 && (
				<Fragment>
					{address2}
					<br />
				</Fragment>
			)}
			{city}, {state && getLabelFromValue(state, FORMS.states)} {zipCode}
			<br />
			{country && getLabelFromValue(country, FORMS.countries)}
		</p>
	);
}

export default Address;
